"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Show Title',
  description: "Allow a title to appear with each item.\n  Note that the placement of the texts (title and description) can also be changed with the option - \"titlePlacement\".",
  isRelevant: function isRelevant() {
    return true;
  },
  type: _constants.INPUT_TYPES.BOOLEAN,
  "default": false
};
exports["default"] = _default;